import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import PostCard from "../components/PostCard";
import Sidebar from "../components/Sidebar";
import { getCategoryBySlug, getPostsByCategory } from "../data/posts";
import NotFound from "./NotFound";

function CategoryDetail() {
  const { slug } = useParams();
  const category = getCategoryBySlug(slug);
  if (!category) return <NotFound />;

  const list = getPostsByCategory(slug);

  return (
    <Container className="py-4">
      <Breadcrumb listProps={{ className: "small mb-3" }}>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>{category.name}</Breadcrumb.Item>
      </Breadcrumb>

      <Row className="g-4">
        <Col lg={8}>
          <h2 className="block-title">Category: {category.name}</h2>
          {list.length === 0 ? (
            <p className="text-muted-2">No posts in this category yet check back soon!</p>
          ) : (
            <Row className="g-4">
              {list.map((p) => (
                <Col md={6} key={p.id}>
                  <PostCard post={p} />
                </Col>
              ))}
            </Row>
          )}
        </Col>
        <Col lg={4}>
          <Sidebar />
        </Col>
      </Row>
    </Container>
  );
}

export default CategoryDetail;
